// import './App.css'
import * as Sentry from "@sentry/react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Wrap Routes component with Sentry for navigation tracing
const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
// frontend/src/App.jsx
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Chat from "./pages/Chat";
import Organization from "./pages/Organization";
import Admin from "./pages/Admin";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./components/pages/org/Dashboard";
import Employees from "./pages/Employees";
import Plans from "./components/pages/org/Plans";
import PaymentVerify from "./pages/PaymentVerify";
import PaymentCancel from "./pages/PaymentCancel";
import Upgrade from "./pages/Upgrade";
import UpgradePlan from "./pages/UpgradePlan";
import ActivateTrial from "./pages/ActivateTrial";
import TrialVerify from "./pages/TrialVerify";
import PaymentMethodVerify from "./pages/PaymentMethodVerify";
import ReactivateVerify from "./pages/ReactivateVerify";
import PartnerSignup from "./pages/PartnerSignup";
import PartnerRequest from "./pages/PartnerRequest";
import ThemeOverrideHandler from "./components/ThemeOverrideHandler";
// frontend/src/App.jsx (privacy policy page import)
import PrivacyPolicy from "./pages/PrivacyPolicy";
// frontend/src/App.jsx (cookies and terms page imports)
import CookiesPolicy from "./pages/CookiesPolicy";
import Terms from "./pages/Terms";
import RefundPolicy from "./pages/RefundPolicy";
import Contact from "./pages/Contact";
import VerifyEmail from "./pages/VerifyEmail";

function App() {
  // Get userData for Employees props
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const organizationId = userData.organization?._id;

  return (
    <ThemeProvider>
      <Router>
        <ThemeOverrideHandler>
          <div className="min-h-screen bg-bg-50">
            <ToastContainer position="bottom-right" theme="colored" />

            <SentryRoutes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/signup" element={<PartnerSignup />} />
              <Route path="/signup/invitation" element={<PartnerSignup />} />
              <Route path="/partner-request" element={<PartnerRequest />} />
              <Route path="/become-partner" element={<PartnerRequest />} />
              <Route path="/payment/verify" element={<PaymentVerify />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/upgrade-plan" element={<UpgradePlan />} />
              {/* New trial activation routes */}
              <Route path="/activate-trial" element={<ActivateTrial />} />
              <Route path="/trial/verify" element={<TrialVerify />} />
              {/* Payment method update routes */}
              <Route
                path="/payment-method/verify"
                element={<PaymentMethodVerify />}
              />
              {/* Subscription reactivation routes */}
              <Route
                path="/subscription/reactivate/verify"
                element={<ReactivateVerify />}
              />
              {/* Privacy policy route */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              {/* Cookies policy route */}
              <Route path="/cookies-policy" element={<CookiesPolicy />} />
              {/* Terms and conditions route */}
              <Route path="/terms" element={<Terms />} />
              {/* Refund policy route */}
              <Route path="/refund-policy" element={<RefundPolicy />} />
              {/* Contact us route */}
              <Route path="/contact" element={<Contact />} />

              {/* Protected Routes */}
              <Route
                element={
                  <ProtectedRoute
                    allowedRoles={["employee", "admin", "individual"]}
                  />
                }
              >
                <Route path="/chat" element={<Chat />} />
                <Route path="/chat/:threadId" element={<Chat />} />
                <Route path="/settings/change-password" element={<Chat />} />
              </Route>

              <Route
                element={<ProtectedRoute allowedRoles={["admin", "owner"]} />}
              >
                <Route path="/org" element={<Organization />}>
                  <Route index element={<Navigate to="dashboard" replace />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route
                    path="employees"
                    element={<Employees organizationId={organizationId} />}
                  />
                  <Route path="plans" element={<Plans />} />
                </Route>
              </Route>

              <Route
                element={
                  <ProtectedRoute
                    allowedRoles={["super_admin", "super admin", "admin"]}
                  />
                }
              >
                <Route path="/admin/*" element={<Admin />} />
              </Route>

              <Route path="*" element={<Navigate to="/" />} />
            </SentryRoutes>
          </div>
        </ThemeOverrideHandler>
      </Router>
    </ThemeProvider>
  );
}

export default App;
